import React from "react";
import { Link, withRouter } from "react-router-dom";
import logo from "../../assets/logom.png";
import "./Login.css";
import { validarlogin } from "../../service/api";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import { DelateLogin } from "../../service/StoreCall";
import { toast } from "react-toastify";
import { Eye, EyeOff } from 'lucide-react';

class LoginPage extends React.Component {
  state = {
    email: "",
    password: "",
    showPass: false,
    loading: false,
    errorMsg: "",
  };

  componentDidMount() {

    const msg = sessionStorage.getItem("toast_after_login");
    if (msg) {
      sessionStorage.removeItem("toast_after_login");
      toast.info(msg, { autoClose: 8000 });
    }    

    DelateLogin();
  }
  isEmailOk = () => {
    const { email } = this.state;
    if (!email) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  setField = (key) => (e) => {
    this.setState({ [key]: e.target.value, errorMsg: "" });
  };

  toggleShowPass = () => {
    this.setState((prev) => ({ showPass: !prev.showPass }));
  };

  onSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = this.state;
    if (!email.trim() || !password) {
      this.setState({ errorMsg: "Completa correo y contraseña." });
      return;
    }
    if (!this.isEmailOk()) {
      this.setState({ errorMsg: "Correo inválido." });
      return;
    }

    try {

      this.setState({ loading: true, errorMsg: "" });
      const resp = await validarlogin(email, password);
    //// consolelog(JSON.stringify(resp))

      if (resp.code == 0) {
        await new Promise((r) => setTimeout(r, 800));
        this.props.history.push("/ventas");
      }
      else {
        toast.info(resp.message);
      }


    } catch (err) {
      this.setState({
        errorMsg: "No se pudo iniciar sesión. Verifica tus datos.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { email, password, showPass, loading, errorMsg } = this.state;
    const emailOk = this.isEmailOk();

    return (

      <div className="mm-shell">

        {(loading == true) ? (
          <SpinnerModal tipo="full" verImagen={true} show={loading} />
        ) : null}

        <main className="mm-center">
          <section className="mm-card" aria-label="Inicio de sesión">
            <div className="mm-logoImgWrap">
              <img className="mm-logoImg" src={logo} alt="Morena Mia Beauty" />
            </div>

            <h1 className="mm-title">Iniciar sesión</h1>

            <form className="mm-form" onSubmit={this.onSubmit}>
              <label className="mm-label">
                <span>Correo electrónico</span>
                <div className={`mm-inputWrap ${!emailOk ? "mm-error" : ""}`}>
                  <span className="mm-icon" aria-hidden="true">@</span>
                  <input
                    className="mm-input"
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    placeholder="nombre@email.com"
                    value={email}
                    onChange={this.setField("email")}
                    aria-invalid={!emailOk}
                  />
                </div>
                {!emailOk && <small className="mm-help">Correo inválido.</small>}
              </label>

              <label className="mm-label">
                <span>Contraseña</span>
                <div className="mm-inputWrap">
                  <span className="mm-icon" aria-hidden="true">🔒</span>
                  <input
                    className="mm-input"
                    type={showPass ? "text" : "password"}
                    autoComplete="current-password"
                    placeholder="••••••••"
                    value={password}
                    onChange={this.setField("password")}
                  />
                  <button
                    type="button"
                    className="mm-eye"
                    onClick={this.toggleShowPass}
                    aria-label={showPass ? "Ocultar contraseña" : "Mostrar contraseña"}
                  >
                    {showPass ? <EyeOff size={18} /> : <Eye size={18} />}

                  </button>
                </div>
              </label>

              <div className="mm-row">
                <Link className="mm-link" to="/recuperar">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>

              {errorMsg ? <small className="mm-help">{errorMsg}</small> : null}

              <button
                className="mm-btn"
                type="submit"
                disabled={loading || !email.trim() || !password || !emailOk}
              >
                {loading ? "INICIANDO..." : "INICIAR SESIÓN"}
              </button>

              <p className="mm-footnote">
                © {new Date().getFullYear()} Morena Mia Beauty. Todos los derechos reservados.
              </p>
            </form>
          </section>
        </main>

      </div>

    );
  }
}

export default withRouter(LoginPage);
